import { datasource } from "./datasource";

export const jobDetailDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("job_detail", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        job_id: {
          type: "string",
        },
        job_service_id: {
          type: "string",
        },
        price: {
          type: "number",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
